var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.altitudeData
    ? _c(
        "div",
        { staticClass: "pr-20", on: { mouseleave: _vm.mouseLeftChart } },
        [
          _vm.altitudeData
            ? _c("line-chart", {
                attrs: {
                  id: "altitude-chart",
                  options: _vm.chartOptions,
                  data: _vm.altitudeData
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.summary
            ? _c(
                "v-layout",
                [
                  _c("v-flex", { attrs: { sm6: "" } }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", [_vm._v("arrow_upward")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.ascent) +
                            " " +
                            _vm._s(_vm.$t("global.units.m"))
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm6: "" } }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", [_vm._v("arrow_downward")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.descent) +
                            " " +
                            _vm._s(_vm.$t("global.units.m"))
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-086c01da", { render: render, staticRenderFns: staticRenderFns })
  }
}